module.exports = __webpack_public_path__ + "media/images/users/user-8-48c25d7e074f6a78a7070a620f4c04a0.jpg";